<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-select v-model="selectedSurveyType" label="Type" required :items="typeOptions"> </v-select>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Start Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menu2"
          v-model="menu2"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="End Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <survey-result-filters
        @transitionproducttypes="selectedTransitionProductTypes = $event"
        @endtypes="selectedEndTypes = $event"
        @corporatetypes="selectedCorporateType = $event"
      />
    </v-row>
    <v-row v-if="startDate && endDate && selectedSurveyType">
      <v-col cols="4">
        <v-btn @click="exportSurveyResults()" :loading="loadingReport">
          Export results
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="results"
      :items-per-page="50"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <router-link class="font-weight-bold" :to="`/clients/${item.userId}`">
            {{ item.name }}
          </router-link>
        </div>
      </template>

      <template v-slot:item.submittedDate="{ item }">
        <div>
          <router-link class="font-weight-bold" :to="`/reporting/survey-results/${decodeId(item.id)}`">
            {{ item.submittedDate }}
          </router-link>
        </div>
      </template>
      <template v-slot:item.resultSnapshot="{ item }">
        <div v-for="result in item.resultSnapshot" :key="result.id">
          <div class="mb-2">
            {{ result.question }}
            <strong>{{ result.answer }}</strong>
          </div>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { SUBSCRIPTION_SURVEYS_QUERY, SUBSCRIPTION_SURVEYS_EXPORT_QUERY } from "@/graphql/queries/survey";
import { decodeId, capitalize } from "@/lib/string";
import SurveyResultFilters from "@/components/reporting/components/SurveyResultFilters";
export default {
  name: "SurveyResults",
  components: { SurveyResultFilters },
  data() {
    return {
      loading: true,
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
      results: [],
      loadingReport: false,
      headers: [
        { text: "Type", value: "surveyType" },
        { text: "Submitted Date", value: "submittedDate" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Product", value: "product" },
        { text: "Coach", value: "coach" },
        { text: "Sub ending", value: "endDate" },
        { text: "Transitioning to", value: "transitionProduct" },
        { text: "Result Snapshot (ex Free Text)", value: "resultSnapshot" },
      ],
      selectedSurveyType: null,
      typeOptions: [
        { value: "Club_Cancel", text: "Club Cancellation" },
        { value: "1_on_1_Cancel", text: "1-on-1 Cancellation" },
        { value: "Life_Cancel", text: "Life Cancellation" },
        { value: "Workoutblock_End", text: "Workout Program End" },
        { value: "Course_End", text: "Course End" },
        { value: "1_on_1_2_Week", text: "1-on-1 2 Week" },
        { value: "1_on_1_7_Week", text: "1-on-1 7 Week" },
        { value: "1_on_1_12_Week", text: "1-on-1 12 Week" },
        { value: "Nutritionblock_End", text: "Nutrition Program End" },
      ],
      selectedEndTypes: null,
      selectedCorporateType: "CUSTOMER",
      selectedTransitionProductTypes: null,
    };
  },
  watch: {
    startDate: function(value) {
      let params = [];
      params.push(`startDate=${value}`);
      if (this.selectedSurveyType) {
        params.push(`selectedSurveyType=${this.selectedSurveyType}`);
      }
      if (this.endDate) {
        params.push(`endDate=${this.endDate}`);
      }
      history.pushState({}, null, this.$route.path + "?" + params.join("&"));
    },
    endDate: function(value) {
      let params = [];
      if (this.selectedSurveyType) {
        params.push(`selectedSurveyType=${this.selectedSurveyType}`);
      }
      if (this.startDate) {
        params.push(`startDate=${this.startDate}`);
      }
      params.push(`endDate=${value}`);
      history.pushState({}, null, this.$route.path + "?" + params.join("&"));
    },
    selectedSurveyType: function(value) {
      let params = [];
      if (this.startDate) {
        params.push(`startDate=${this.startDate}`);
      }
      if (this.endDate) {
        params.push(`endDate=${this.endDate}`);
      }
      params.push(`selectedSurveyType=${value}`);
      history.pushState({}, null, this.$route.path + "?" + params.join("&"));
    },
  },
  created() {
    if (this.$route.query.startDate) {
      this.startDate = this.$route.query.startDate;
    }
    if (this.$route.query.endDate) {
      this.endDate = this.$route.query.endDate;
    }
    if (this.$route.query.selectedSurveyType) {
      this.selectedSurveyType = this.$route.query.selectedSurveyType;
    }
  },
  methods: {
    decodeId(value) {
      return decodeId(value);
    },
    exportSurveyResults() {
      this.loadingReport = true;
      this.$apollo
        .query({
          query: SUBSCRIPTION_SURVEYS_EXPORT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            surveyType: this.selectedSurveyType,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.loadingReport = false;
            this.$toasted.success("The report will be emailed to you. This may take up to 10 minutes. ", {
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
  },
  apollo: {
    subscriptionSurveys: {
      query: SUBSCRIPTION_SURVEYS_QUERY,
      variables() {
        return {
          submittedDate_Gte: this.startDate,
          submittedDate_Lte: this.endDate,
          isSubmitted: true,
          orderBy: "-submittedDate",
          surveyType: this.selectedSurveyType,
          endTypes: this.selectedEndTypes,
          endTransitionProductTypes: this.selectedTransitionProductTypes,
          corporateTypes: this.selectedCorporateType === "CUSTOMER",
        };
      },
      result(response) {
        if (response.data) {
          this.loading = false;

          this.results = response.data.subscriptionSurveys.edges.map((item) => {
            const answerSet = item.node.answerSet.filter(
              (item) => item.surveyQuestion?.question.questionType !== "FREE_TEXT"
            );
            const answerResults = answerSet.map((item) => {
              let answer;
              if (item.answer) {
                answer = item.answer;
              } else {
                answer = item.option?.title;
              }
              return {
                id: item.id,
                question: item.surveyQuestion?.question?.title,
                answer: answer,
                questionType: item.surveyQuestion?.question?.questionType,
              };
            });

            return {
              id: item.node.id,
              userId: decodeId(item.node.subscription.user.id),
              surveyType: capitalize(item.node.survey.surveyType.replace("A_", "")),
              submittedDate: item.node.submittedDate,
              name: `${item.node.subscription.user.firstName} ${item.node.subscription.user.lastName}`,
              coach: item.node.subscription.coach
                ? `${item.node.subscription.coach.firstName} ${item.node.subscription.coach.lastName}`
                : "",
              email: item.node.subscription.user.email,
              product: capitalize(item.node.subscription.product.type),
              endDate: item.node.subscription.endDate
                ? this.$moment(item.node.subscription.endDate).format("YYYY-MM-DD")
                : "",
              transitionProduct: item.node.subscription?.transitionProductVariant?.product?.title,
              resultSnapshot: answerResults,
            };
          });
        }
      },
    },
  },
};
</script>
